import React from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

export const getLastDayOfMonth = (date) => {
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return lastDay;
};

const CalendarWeek = ({ date, setDate, loading = false, buscar = null, selectionMode = 'single', view = 'date', dateFormat=null, IdTipo = null }) => {
    return (
        <span>
            <Calendar
                showIcon
                // monthNavigator
                // yearNavigator
                // yearRange='2010:2030'
                value={date}
                // id="calendar"
                // onChange={e => setDate(e.value)}
                onChange={(e) => setDate(IdTipo === 1 ? getLastDayOfMonth(e.value) : e.value)}
                showButtonBar
                dateFormat={dateFormat ? dateFormat : "dd/mm/yy"}
                selectionMode={selectionMode} 
                disabled={loading}
                view={view}
                // style={{ zIndex: 5000 }}
                />

            {buscar && <Button
                icon="pi pi-search"
                type="button"
                className=" listado__botones ms-2"
                loading={loading}
                tooltip="Buscar"
                tooltipOptions={{ className: 'purple-tooltip', position: 'top' }}
                style={{ height: '100%' }}
                onClick={buscar} >
                    </Button>}
        </span>
    )
}

export default CalendarWeek